module.exports = __webpack_public_path__ + "img/mg-abc.c4077bc4.png";